"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var highstock_1 = __importDefault(require("highcharts/highstock"));
var highcharts_more_1 = __importDefault(require("highcharts/highcharts-more"));
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var Head_1 = require("../parts/Head");
var PlotBand_1 = require("../parts/PlotBand");
var PlotLine_1 = require("../parts/PlotLine");
var XAxis_1 = require("../parts/XAxis");
var YAxis_1 = require("../parts/YAxis");
var Title_1 = require("../parts/Title");
var Legend_1 = require("../parts/Legend");
var Credits_1 = require("../parts/Credits");
var Tooltip_1 = require("../parts/Tooltip");
var Subtitle_1 = require("../parts/Subtitle");
var Navigator_1 = require("../parts/Navigator");
var RangeSelector_1 = require("../parts/RangeSelector");
var utils_1 = require("../../utils");
var series_1 = require("../series");
/**
 * TimeSeries charts display datasets over the span of a period of time.
 * This component requires a commercial license. To find out more about licensing costs write an email to
 * [Martin Hlucka](mailto:Martin.Hlucka@honeywell.com)
 * @nonfree
 * @child ./series/Line/Line.ts
 * @child ./series/Area/Area.ts
 * @child ./series/AreaRange/AreaRange.ts
 * @child ./series/Column/Column.ts
 * @child ./series/ColumnRange/ColumnRange.ts
 * @child ./parts/Credits/Credits.ts
 * @child ./parts/Legend/Legend.ts
 * @child ./parts/Navigator/Navigator.ts
 * @child ./parts/PlotBand/PlotBand.ts
 * @child ./parts/PlotLine/PlotLine.ts
 * @child ./parts/RangeSelector/RangeSelector.ts
 * @child ./parts/Subtitle/Subtitle.ts
 * @child ./parts/Title/Title.ts
 * @child ./parts/Tooltip/Tooltip.ts
 * @child ./parts/XAxis/XAxis.ts
 * @child ./parts/YAxis/YAxis.ts
 *
 */
var TimeSeries = /** @class */ (function (_super) {
    __extends(TimeSeries, _super);
    function TimeSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            headOptions: {},
            currentRange: {
                from: new Date(),
                to: new Date()
            },
            grouping: {
                type: '',
                count: 0,
                active: ''
            }
        };
        _this.debouncerTime = 100;
        _this.updateHead = function (headOptions) {
            var previousOptions = JSON.stringify(_this.state.headOptions);
            var nextOptions = JSON.stringify(headOptions);
            if (previousOptions !== nextOptions) {
                _this.setState({ headOptions: headOptions });
            }
        };
        _this.genClasses = function () {
            var className = _this.props.className;
            var classes = 'ui forge chart-wrap basic-chart';
            if (className) {
                classes += " " + className;
            }
            return classes;
        };
        _this.handleResize = function (width, height) {
            var onResize = _this.props.onResize;
            var chart = _this.state.chart;
            if (chart && Object.keys(chart).length) {
                try {
                    chart.reflow();
                }
                catch (e) { }
                _this.forceUpdate();
            }
            if (onResize) {
                onResize(width, height);
            }
        };
        _this.updateGroupRange = function (grouping, range) {
            _this.setState({ grouping: grouping, currentRange: range });
        };
        _this.updateDebouncer = function (min, max) {
            clearTimeout(_this.debouncer);
            var grouping = {
                type: '',
                count: 0,
                active: ''
            };
            var range = {
                from: new Date(min),
                to: new Date(max)
            };
            _this.debouncer = setTimeout(function () {
                _this.updateGroupRange(grouping, range);
            }, _this.debouncerTime);
        };
        _this.composeOptions = function (initialRun) {
            var props = _this.props;
            var _a = utils_1.typeChildren(props.children), xAxis = _a.xAxis, yAxis = _a.yAxis, legend = _a.legend, navigator = _a.navigator, rangeSelector = _a.rangeSelector, title = _a.title, tooltip = _a.tooltip, subtitle = _a.subtitle, credits = _a.credits, series = _a.series;
            var xAxisModifiers = { onSetExtremes: _this.updateDebouncer };
            var base = utils_1.baseOptions(props, { legend: legend, series: series });
            var options = __assign(__assign({}, base), { series: series_1.seriesOptions(series, tooltip, initialRun), xAxis: XAxis_1.xAxisOptions(props, xAxis, xAxisModifiers), yAxis: YAxis_1.yAxisOptions(props, yAxis), legend: Legend_1.legendOptions(props, legend), navigator: Navigator_1.navigatorOptions(props, navigator), tooltip: Tooltip_1.tooltipOptions(props, tooltip), credits: Credits_1.creditsOptions(credits) });
            var headOptions = {
                rangeSelector: RangeSelector_1.rangeSelectorOptions(props, rangeSelector),
                title: Title_1.titleOptions(props, title),
                subtitle: Subtitle_1.subtitleOptions(props, subtitle)
            };
            return { options: options, headOptions: headOptions };
        };
        return _this;
    }
    TimeSeries.prototype.componentDidMount = function () {
        var _a = this.composeOptions(true), options = _a.options, headOptions = _a.headOptions;
        highcharts_more_1.default(highstock_1.default);
        var chart = highstock_1.default.stockChart(this.highstockRoot, options);
        var _b = chart.xAxis[0].getExtremes(), dataMin = _b.dataMin, dataMax = _b.dataMax;
        var currentRange = {
            from: new Date(dataMin),
            to: new Date(dataMax)
        };
        this.setState({ chart: chart, headOptions: headOptions, currentRange: currentRange });
    };
    TimeSeries.prototype.componentDidUpdate = function () {
        var _a = this.composeOptions(), options = _a.options, headOptions = _a.headOptions;
        this.updateHead(headOptions);
        this.state.chart.update(options, true, true);
    };
    TimeSeries.prototype.componentWillUnmount = function () {
        clearTimeout(this.debouncer);
        var chart = this.state.chart;
        if (chart) {
            chart.destroy();
        }
    };
    TimeSeries.prototype.render = function () {
        var _this = this;
        var _a = this.state, headOptions = _a.headOptions, currentRange = _a.currentRange, grouping = _a.grouping, chart = _a.chart;
        return (React.createElement("div", { className: this.genClasses() },
            chart && (React.createElement(Head_1.Head, __assign({}, headOptions, { chart: chart, currentRange: currentRange, grouping: grouping, updateGroupRange: this.updateGroupRange }))),
            React.createElement("div", { className: "highcharts-root", ref: function (ref) { return (_this.highstockRoot = ref); } },
                React.createElement(react_resize_detector_1.default, __assign({ refreshMode: "throttle", refreshRate: 100, handleWidth: true, handleHeight: true, skipOnMount: false }, this.props.ResizerProps, { onResize: this.handleResize })))));
    };
    TimeSeries.defaultProps = {
        animation: true,
        showLegend: true,
        showNavigator: true,
        showRangeSelector: true,
        showTooltips: true,
        showScrollbar: true,
        colors: utils_1.defaultColors,
        dateTimeLabelFormats: utils_1.defaultDateTimeLabelFormats,
        series: {},
        pies: {},
        spacing: [10, 10, 15, 10],
        backgroundColor: '#FFFFFF00',
        chartType: 'timeseries',
    };
    TimeSeries.Credits = Credits_1.Credits;
    TimeSeries.Legend = Legend_1.Legend;
    TimeSeries.Navigator = Navigator_1.Navigator;
    TimeSeries.PlotBand = PlotBand_1.PlotBand;
    TimeSeries.PlotLine = PlotLine_1.PlotLine;
    TimeSeries.RangeSelector = RangeSelector_1.RangeSelector;
    TimeSeries.Subtitle = Subtitle_1.Subtitle;
    TimeSeries.Title = Title_1.Title;
    TimeSeries.Tooltip = Tooltip_1.Tooltip;
    TimeSeries.XAxis = XAxis_1.XAxis;
    TimeSeries.YAxis = YAxis_1.YAxis;
    TimeSeries.Area = series_1.Area;
    TimeSeries.AreaRange = series_1.AreaRange;
    TimeSeries.CandleStick = series_1.CandleStick;
    TimeSeries.Column = series_1.Column;
    TimeSeries.ColumnRange = series_1.ColumnRange;
    TimeSeries.Line = series_1.Line;
    return TimeSeries;
}(React.Component));
exports.default = TimeSeries;
//# sourceMappingURL=TimeSeries.js.map